import type { WalletTopUpsTranslations } from "../interfaces/walletTopUps";

export const walletTopUpsTranslations: WalletTopUpsTranslations = {
  page_title: "Cargas a billeteras",
  page_subtitle:
    "Acredita fondos de Coloca en la billetera de un cliente. Cada carga pide tu código de verificación, queda registrada y le llega el comprobante al cliente.",
  action_refresh: "Actualizar el historial",
  action_new: "Nueva carga",
  action_retry: "Reintentar",
  filter_organization: "Organización",
  filter_all_option: "Todas las organizaciones",
  filter_all_hint: "Se muestran las cargas de todas las organizaciones.",
  filter_org_hint: "Se muestran solo las cargas de esta organización.",

  empty_title: "Todavía no hay cargas",
  empty_description: "Las cargas que hagas aparecen aquí con su comprobante.",
  col_date: "Fecha",
  col_organization: "Organización",
  col_amount: "Monto",
  col_concept: "Concepto y nota interna",
  col_reference: "Referencia",
  col_by: "Hecha por",
  col_receipt: "Comprobante",
  card_note: "Nota interna: {{note}}",
  card_by: "Hecha por {{email}}",

  dialog_title: "Cargar una billetera",
  dialog_title_review: "Revisa la carga",
  dialog_title_done: "Carga acreditada",
  dialog_title_processing: "Acreditando la carga…",
  dialog_description: "El saldo sale de los fondos de Coloca y queda disponible para el cliente al instante.",
  dialog_description_review: "Confirma la organización, la billetera y el monto antes de autorizar.",
  dialog_description_done: "El cliente ya ve la recarga en su extracto.",
  dialog_description_processing:
    "Estamos acreditando el saldo y enviando el comprobante por correo; puede tardar unos segundos. No cierres esta ventana.",
  processing_from: "Coloca Payments",
  processing_transit_aria:
    "{{amount}} {{currency}} viajan de Coloca Payments a la billetera {{currency}} de {{name}}.",
  action_cancel: "Cancelar",
  action_review: "Revisar carga",
  action_back: "Volver",
  action_confirm: "Autorizar carga",
  action_another: "Hacer otra carga",
  action_close: "Cerrar",

  field_organization: "Organización",
  field_organization_required_hint: "Elige la organización que recibe la carga.",
  field_organization_hint: "La carga se acredita en una billetera de esta organización.",
  organization_unknown: "la organización",
  field_wallet: "Billetera",
  field_wallet_hint: "La moneda de la billetera es la moneda de la carga.",
  field_wallet_placeholder: "Elige una billetera",
  field_wallet_none:
    "Esta organización no tiene billeteras activadas. Actívale una desde Billeteras y vuelve a intentarlo.",
  field_wallet_option: "{{currency}} · saldo {{balance}}",
  field_wallet_option_inactive: "{{currency}} · {{status}}",
  wallet_frozen: "congelada",
  wallet_closed: "cerrada",
  field_amount: "Monto",
  field_amount_hint: "En {{currency}}. Se suma al saldo disponible.",
  field_concept: "Concepto",
  field_concept_hint: "El cliente lo ve en su extracto, en el correo y en el comprobante.",
  concept_default: "Recarga de saldo",
  field_note: "Nota interna",
  field_note_hint: "Solo la ve el equipo de Coloca: por qué se carga y dónde están los fondos.",
  field_note_placeholder: "Ej.: fondos ya recibidos en el proveedor, solicitud de soporte #482",

  validation_wallet: "Elige la billetera que recibe la carga.",
  validation_amount: "Escribe un monto mayor que cero.",
  validation_amount_precision: "{{currency}} admite como máximo {{digits}} decimales.",
  validation_concept: "Escribe el concepto que verá el cliente.",
  validation_note: "Escribe una nota interna para el registro.",

  review_organization: "Organización",
  review_wallet: "Billetera",
  review_wallet_value: "Billetera {{currency}}",
  review_balance_before: "Saldo disponible ahora",
  review_amount: "Recarga de Coloca Payments",
  review_balance_after: "Saldo después de la carga",
  review_concept: "Concepto (lo ve el cliente)",
  review_note: "Nota interna",
  review_client_sees:
    "El cliente la verá como una recarga de Coloca Payments y recibirá el comprobante por correo. A ti también te llega una copia.",
  review_irreversible: "La carga es inmediata y no se puede deshacer desde el panel.",
  review_checkbox: "Revisé la organización, la billetera y el monto",

  two_factor_required:
    "Para cargar billeteras necesitas la verificación en dos pasos activa. Actívala en Configuración y vuelve.",
  two_factor_description: "Vas a cargar {{amount}} {{currency}} a {{name}}.",

  unresolved_title: "Una carga quedó sin confirmar",
  unresolved_text:
    "Se autorizó una carga de {{amount}} («{{concept}}») a esta organización y no llegó la respuesta, así que no sabemos si se acreditó. Compruébala antes de hacer otra.",
  unresolved_text_retry:
    "No llegó la respuesta, así que no sabemos si esta carga se acreditó. Compruébala, o autorízala de nuevo: si ya se había hecho, no se acredita dos veces.",
  unresolved_action: "Comprobar la carga",
  unresolved_pending: "Todavía se está procesando. Vuelve a comprobarla en unos segundos.",
  unresolved_unknown: "No pudimos comprobarla. Vuelve a intentarlo en un momento.",
  unresolved_not_placed: "La carga que quedó sin confirmar no se acreditó. Ya puedes hacer la carga.",
  top_up_busy:
    "Otra pestaña está enviando una carga a esta organización. Espera a que termine y vuelve a autorizar; no se envió nada.",
  unresolved_blocked: "Hay una carga a esta organización sin confirmar. Compruébala antes de hacer otra.",

  done_recovered:
    "La carga que quedó sin confirmar sí se acreditó. Este es su comprobante; comprobarla no acreditó nada de nuevo.",
  done_replayed:
    "Esta carga ya se había hecho con estos mismos datos. No se acreditó de nuevo ni se enviaron correos.",
  done_receipt_label: "Comprobante de recarga",
  done_credited: "Acreditado",
  done_amount: "Monto acreditado",
  done_beneficiary: "Beneficiario",
  done_wallet: "Billetera",
  done_concept: "Concepto",
  done_origin: "Origen",
  done_emails_label: "Correos enviados",
  email_pending: "Estamos enviando el comprobante {{who}}.",
  email_sent: "Enviamos el comprobante {{who}}.",
  email_failed: "No pudimos enviar el correo {{who}}. Descarga el comprobante y compártelo.",
  email_no_address: "No enviamos correo {{who}}: no tiene un correo registrado.",
  email_to_operator: "a tu correo",
  email_to_accounting: "al correo de contabilidad",
  email_to_organization: "a la organización",

  receipt_download: "Descargar comprobante",
  receipt_download_for: "Descargar el comprobante {{reference}}",
  receipt_share: "Compartir",
  receipt_share_title: "Comprobante de recarga {{reference}}",
  receipt_error: "No pudimos obtener el comprobante: {{message}}",
  kind_incident_refund: "Reembolso",
  done_receipt_label_refund: "Comprobante de reembolso",
};
